import { Stack } from '@mui/material';

import { Icon, Mask } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { CoparticipationColumnIdEnum } from '@flows/private/financial/pages/CoparticipationPreviewReport/types';

import type { CoparticipationMainRowProps } from './types';
import {
  StyledActionCell,
  StyledIconButton,
  StyledSimpleText,
  StyledSingleLineText,
  StyledTableCell,
  StyledTableRow,
  StyledThreeLineText,
} from './styles';

export function CoparticipationMainRow({
  row,
  columnsMainRow,
  open,
  onToggle,
}: CoparticipationMainRowProps) {
  return (
    <StyledTableRow>
      {columnsMainRow.map((column, index) => {
        const isFirst = index === 0;
        const isLast = index === columnsMainRow.length - 1;
        const isWithThreeLines = [
          CoparticipationColumnIdEnum.Beneficiary,
          CoparticipationColumnIdEnum.Holder,
        ].includes(column.id as CoparticipationColumnIdEnum);

        return (
          <StyledTableCell
            key={column.id}
            align={column.align}
            isFirst={isFirst}
            isLast={isLast}
            open={open}
          >
            {isWithThreeLines ? (
              <Stack>
                <StyledThreeLineText variant="text">
                  {column.id === CoparticipationColumnIdEnum.Holder
                    ? row.holderCode
                    : row.beneficiaryCode}
                </StyledThreeLineText>

                <StyledSingleLineText variant="text" isBold>
                  {row[column.id as unknown as keyof typeof row]}
                </StyledSingleLineText>

                <StyledThreeLineText variant="text">
                  {column.id === CoparticipationColumnIdEnum.Holder
                    ? row.holderDocument
                    : row.beneficiaryDocument}
                </StyledThreeLineText>
              </Stack>
            ) : (
              <StyledSimpleText variant="text" isBold={!isFirst && !isLast}>
                {column.id === CoparticipationColumnIdEnum.Total
                  ? Mask.currency(
                      Number(row[column.id as unknown as keyof typeof row]),
                    )
                  : row[column.id as unknown as keyof typeof row] ?? '-'}
              </StyledSimpleText>
            )}
          </StyledTableCell>
        );
      })}

      <StyledActionCell align="center" className="main-row" open={open}>
        <StyledIconButton
          aria-label="expand row"
          size="small"
          onClick={() => onToggle(row.id)}
        >
          <Icon
            name={open ? 'actions-b2b-chevron-up' : 'actions-b2b-chevron-down'}
            color={open ? NEW_COLORS.SECONDARY[600] : NEW_COLORS.GRAYSCALE[800]}
          />
        </StyledIconButton>
      </StyledActionCell>
    </StyledTableRow>
  );
}
